import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Button from "../../buttons/Button";
import ConfirmDialog from "../../dialogs/ConfirmDialog";
import Grid from "../../dataGrid/DataGrid";
import Tabs from "../../TabsWrapper";
import Tab from "../../Tab";
import flags from "../../utils/flags";
import withMeta from '../../utils/withMeta';
import { useFirstRender } from '../../utils/hooks';
import { showMsg } from '../../utils/logger';
import { processFilter } from '../../dataGrid/gridHelper';

let _filter, _sort;
let _page = { skip: 0, take: 50 };
const UzApl = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState([]);
  const [defaultSelected, setDefaultSelected] = useState([]);
  const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
  const [schema, setSchema] = useState([]);
  const getSchema = props.meta.getSchema;

  let fixedFilter = { filters: [{ field: "Zrus", operator: "eq", value: false }, { field: "IApl", operator: "neq", value: 3 }, { field: "IApl", operator: "lt", value: 1000 }] };

  useEffect(() => {
    const getGridSchema = async () => {
      const res = await getSchema("IApl", props.db);
      setSchema(res.Grid)
      return res.Grid
    };

    getGridSchema()
  }, [getSchema, props.db])


  // aby useEffect(..., [props.refresh]) nerobil kontrolu _.isEqual(oldSelected, newSelected) pri 1. rendery, 
  // lebo prv sa spusta useEffect az po nom getList(), ktory nastavi oldSelected a newSelected
  const firstRender = useFirstRender();

  const getSelected = async () => {
    try {
      const res = await props.meta.getList("IUzApl", { filters: [{ field: "Uz.IUz", operator: "eq", value: props.uz.IUz }, { field: "Zrus", operator: "eq", value: false }] }, [], { skip: 0, take: 1000 }, props.db);
      const selected = res.Data.Items.map(x => x.Apl);
      setSelected(selected);
      setDefaultSelected(selected);
      props.getListSuccess(res);
    }
    catch (error) {
      setSelected([]);
      setDefaultSelected([]);
      props.getListFailure(error);
    }
  }

  const onChange = (filter, sort, page) => {
    _filter = filter ? filter : _filter;
    _sort = sort ? sort : _sort;
    _page = page ? page : _page;
  }

  const getList = async () => {
    try {
      setIsLoading(true);
      setData([]);
      setTotal(0);
      const f = processFilter(_filter, fixedFilter)
      const res = await props.meta.getList("IApl", f, _sort, _page, props.db);
      await getSelected();
      setData(res.Data.Items);
      setTotal(res.Data.TotalRecords);
      setIsLoading(false);
      props.getListSuccess(res);
    }
    catch (error) {
      setIsLoading(false);
      setData([]);
      setTotal(0);
      props.getListFailure(error);
    }
  }

  const handleSelect = (selected) => {
    setSelected(selected);
  }

  useEffect(() => {
    const openConfirmDialog = () => {
      setIsOpenConfirmDialog(true);
    };

    if (!firstRender) {
      const oldSelected = defaultSelected.map(({ selected: _, ...x }) => x);
      const newSelected = selected.map(({ selected: _, ...x }) => x);
      if (_.isEqual(oldSelected, newSelected)) {
        onNext();
      }
      else {
        openConfirmDialog();
      }
    }
    // eslint-disable-next-line
  }, [props.refresh]);

  const onNext = async () => {
    try {
      if (selected.length === 0) {
        props.showMsg("Používateľ nemá priradené žiadne aplikácie", "error");
        return;
      }
      const newSelected = selected.filter(el => !defaultSelected.some(x => x.IApl === el.IApl))
      const oldSelected = defaultSelected.filter(el => !selected.some(x => x.IApl === el.IApl))
      for (const x of newSelected) {
        const data = {
          IUzApl: 0,
          Apl: x,
          Uz: props.uz
        }
        await props.meta.create("IUzApl", data, props.db);
      }
      for (const x of oldSelected) {
        const res = await props.meta.getList("IUzApl", { filters: [{ field: "Uz.IUz", operator: "eq", value: props.uz.IUz }, { field: "Apl.IApl", operator: "eq", value: x.IApl }] }, [], { skip: 0, take: 10 });
        const id = res.Data.Items[0].IUzApl;
        await props.meta.delete("IUzApl", id, props.db);
      }
      props.setApl(selected);
    }
    catch (error) {
      await getSelected();
      props.createFailure(error);
    }
  }

  const onCloseConfirmDialog = () => {
    setIsOpenConfirmDialog(false);
  }

  const onConfirmDialog = () => {
    onCloseConfirmDialog();
    if (defaultSelected.length > 0) {
      props.setApl(defaultSelected);
    }
    else {
      getSelected();
      props.showMsg("Používateľ nemá priradené žiadne aplikácie", "error");
    }
  }

  return (
    <>
      <Tabs localTabsType>
        <Tab title="">
          <Grid
            primaryField="IApl"
            isLoading={isLoading}
            data={data}
            total={total}
            schema={schema || []}
            onChange={onChange}
            onGetList={getList}
            onGet={() => { }}
            selected={selected}
            onSelect={handleSelect}
            hidden={flags.LEFT_TOOLBAR | flags.DETAIL | flags.CANCEL | flags.DELETE | flags.PRINT | flags.RESET | flags.COLUMN_MENU}
            multiple
            fixedFilter={fixedFilter}
            withMeta
            page={_page}
            sort={_sort}
            updateSort={() => { }}
            userFilterExtended={[]}
          />
        </Tab>
      </Tabs>
      <Button
        buttonWrapperClassName={"next-button"}
        label={"Priradiť aplikácie"}
        onClick={onNext}
        disabled={selected.length === 0}
        primary
      />
      <ConfirmDialog
        isOpen={isOpenConfirmDialog}
        onClose={onCloseConfirmDialog}
        onConfirm={onConfirmDialog}
        text={"Máte rozpracovaný záznam. Chcete zahodiť zmeny?"}
        confirmText="Áno"
        cancelText="Nie"
      />
    </>
  );
}

UzApl.propTypes = {
  refresh: PropTypes.number,
  uz: PropTypes.object.isRequired,
  setApl: PropTypes.func.isRequired
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = dispatch => ({
  getListSuccess: res => dispatch({ type: 'GET_LIST_SUCCESS', res }),
  getListFailure: error => dispatch({ type: 'GET_LIST_FAILURE', error }),
  createFailure: error => dispatch({ type: 'CREATE_FAILURE', error }),
  showMsg: (msg, msgType = 'ok') => dispatch(showMsg(msg, msgType))
})

export default withMeta(connect(mapStateToProps, mapDispatchToProps)(UzApl));
